import { useAuth0 } from 'Auth';
import { env } from 'Shared/constants/env';
import { useEffect } from 'react';

export const useSurvicate = () => {
  const { user } = useAuth0();

  useEffect(() => {
    if (window._sva && user) {
      window._sva.setVisitorTraits({
        portalUserId: user.id,
        environment: env.survicateEnvironment,
      });
    }
  }, [user]);
};
